import BaseApi from './BaseApi'

class LanguagesApi extends BaseApi {
  get languagesUrl () {
    return 'languages'
  }

  fetchingLanguages () {
    return this.getJson(this.languagesUrl)
  }
}
export default LanguagesApi

